// CSS
import '../scss/app.scss';

// JS
import * as bootstrap from 'bootstrap';
import loadingAttributePolyfill from 'loading-attribute-polyfill';
import { initAjaxForm } from './ajax';
import { initAjaxLink } from './ajax';
import { initBoxLink } from './box-link';
import { initCookieNotice } from './cookies';
import { initGallery } from './gallery';
import { initScrollHeader } from './scrollHeader';
import './breakpoint';

// Ajax form
initAjaxForm();
$(document).on('change', '#cart input.quantity', function (e) {
  e.preventDefault();
  $(this).closest('.ajax-form').submit();
});
$(document).on('click', '.ajax-cart-delete', function (e) {
  e.preventDefault();
  $('input.quantity', $(this).closest('.row')).val(0).trigger('change');
});

// Ajax link
initAjaxLink();

// Box link
initBoxLink();

// Cookie notice
initCookieNotice();

// Gallery
initGallery();

// Scroll header
initScrollHeader();

// global, shared javascript
$(document).ajaxSend(function (event, request, settings) {
  // add ajax class only when request is not resolved quickly (to show loading effect)
  setTimeout(function () {
    if (request.readyState != 4) {
      $('body').addClass('ajax');
    }
  }, 300);
  // setting headers
  let csrfToken = document
    .querySelector('meta[name="X-CSRF-Token"]')
    .getAttribute('content');
  request.setRequestHeader('X-CSRF-Token', csrfToken);
});
$(document).ajaxComplete(function (event, request, settings) {
  $('body').removeClass('ajax');
});

// logo
$(window).scroll(function (event) {
  var scroll = $(window).scrollTop();
  if (scroll > 300) {
    $('.logo').addClass('v2');
  } else {
    $('.logo').removeClass('v2');
  }
});

// navigation
$(function () {
  $('.has-subnav ul').hide();
  $('.has-subnav.active-ancestor ul').show();
  $(document).on('click', '.has-subnav > a', function (e) {
    e.preventDefault();
    let liElement = $(this).parent('.has-subnav');
    liElement.toggleClass('active-ancestor');
    $('ul', liElement).toggle();
  });

  $(document).on('click', '.navbar-toggler', function (e) {
    $('.icon-close, .icon-menu', this)
      .toggleClass('icon-close')
      .toggleClass('icon-menu');
    $('.main, .footer').toggle();
  });
});

// alignement and size of the left header

let headerWidthReize = (isMobile) => {
  if (!isMobile) {
    let headerWidth = $('body > .container').width() - $('.main').width();
    $('header.navbar').width(headerWidth);
    $('.page-title').width($('.main').width() - 48);
  }
};

document.addEventListener('breakpoint', function (event) {
  headerWidthReize(event.isMobile);
});
